import { render, staticRenderFns } from "./m-modal-authentication.vue?vue&type=template&id=b44806e4&"
import script from "./m-modal-authentication.vue?vue&type=script&lang=js&"
export * from "./m-modal-authentication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports